import { FeatureGroup } from 'react-leaflet';

export default class SortingFeatureGroup extends FeatureGroup {
  componentDidUpdate(prevProps) {
    /*
     * Leaflet GeoJSON layers have no concept of z-index. To achieve a similar
     * effect we use a "priority" prop to determine the order in which
     * "bringToFront()" calls are made. This should behave very similarly to z-index.
     */
    this.updateLeafletElement(prevProps, this.props);

    // eslint-disable-next-line no-underscore-dangle
    const layers = this.leafletElement._layers;

    Object.values(layers)
      .sort((layerA, layerB) => layerA.options.priority - layerB.options.priority)
      .forEach(layer => {
        layer.bringToFront();
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/SortingFeatureGroup/index.js